import "./style.css";

const MAX_ITEMS = 9;
const MAX_LEFT = (MAX_ITEMS - 1) / 2;

const Paginacao = ({ limit, total, offset, setOffset }) => {
  const current = offset ? (offset / limit) * 20 : 0;
  const pages = Math.ceil(total / limit);
  const maxFirst = Math.max(pages - (MAX_ITEMS - 1), 1);
  const first = Math.min(Math.max(current - MAX_LEFT, 1), maxFirst);

  function onPageChangeMenos() {
    setOffset(offset - 1);
  }

  function onPageChangeMais() {
    setOffset(offset + 1);
  }

  function onPageChangeUltima() {
    setOffset(pages - 1);
  }

  function onPageChange(page) {      
    setOffset(page - 1);
  }

  return (
    <ul className="pagination">
      <li>
        <button
          className="btn btn-primary"
          onClick={() => onPageChangeMenos()}
          disabled={(current - 1) === -1}
        >
          Anterior
        </button>
      </li>
      {Array.from({ length: Math.min(MAX_ITEMS, pages) })
        .map((_, index) => index + first)
        .map((page) => (
          <li key={page}>
            <button
              onClick={() => onPageChange(page)}
              className={
                (page - 1) === (current)
                  ? "pagination__item--active"
                  :  "pagination__item--inactive"
              }
            >
              {page}
            </button>
          </li>
        ))}
      <li>
        <button
          className="btn btn-primary"
          onClick={() => onPageChangeMais()}
          disabled={current === (pages - 1)}
        >
          Próxima
        </button>
      </li>
      <li>
        <button className="btn btn-primary"
        onClick={() => onPageChangeUltima()}
        disabled={current === (pages - 1)}>
        Último  
        </button>
      </li>
    </ul>
  );
};

export default Paginacao;
